import { z } from 'zod';

export const ingredientSchema = z.object({
  name: z.string().min(1, 'Ingredient name is required'),
  quantity: z.number().positive('Quantity must be positive'),
  unit: z.string().min(1, 'Unit is required'),
});

export const recipeSchema = z.object({
  title: z
    .string()
    .min(3, 'Title must be at least 3 characters')
    .max(100, 'Title must be less than 100 characters'),
  category: z
    .string()
    .min(1, 'Category is required')
    .describe('Recipe category')
    .refine((val) => val.length > 0, {
      message: 'Please select a category',
    }),
  ingredients: z
    .array(ingredientSchema)
    .min(1, 'At least one ingredient is required'),
  instructions: z
    .array(z.string().min(1, 'Instruction step cannot be empty'))
    .min(1, 'At least one instruction step is required'),
  cookingTime: z.number().positive('Cooking time must be positive'),
  prepTime: z.number().positive('Prep time must be positive'),
  servings: z.number().positive('Servings must be positive'),
  difficulty: z.enum(['easy', 'medium', 'hard']),
  dietaryTags: z
    .union([
      z.string().transform(str => {
        if (!str) return [];
        return str
          .split(/[,\s]+/)
          .map(tag => tag.trim())
          .filter(Boolean);
      }),
      z.array(z.string()),
      z.undefined()
    ])
    .transform(val => {
      if (!val) return [];
      if (Array.isArray(val)) return val;
      return [];
    })
    .default([]),
});

export type RecipeInput = z.infer<typeof recipeSchema>;